export const offerApi = env => {
  return env === 'production'
    ? 'http://ms.prod.local.sold.com:9000/predictions/v1/data'
    : 'http://ms.dev.local.sold.com:9000/predictions/v1/data';
};

export const signUp = env => {
  return env === 'dev'
    ? 'https://3yi0eeud6k.execute-api.us-east-1.amazonaws.com/dev/new'
    : null;
};
